module.exports = __webpack_public_path__ + "static/media/child_usage0.a04ccb05.png";